function readMore() {
    var dots = document.getElementById("dots");
    var shortText = document.getElementById("col-description-short");
    var moreText = document.getElementById("col-description-full");
    var btnText = document.getElementById("readBtn");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read More";
        moreText.style.display = "none";
        shortText.style.display = "inline";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read Less";
        moreText.style.display = "inline";
        shortText.style.display = "none";
    }
}